import React from "react";
import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, COMBO_BOX, CODE, DATE, INPUT_NUMBER} = FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã Thuốc",
    name: "maThuoc",
    rules: [{required: true, message: "Chưa nhập  thuốc"}],
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT,
    label: "Tên thuốc",
    name: "tenThuoc",
    rules: [{required: true, message: "Chưa nhập tên thuốc"}],
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: COMBO_BOX,
    label: "Hoạt chất",
    name: "idHoatChat",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT,
    label: "Hàm lượng",
    name: "hamLuong",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: COMBO_BOX,
    label: "Dạng bào chế",
    name: "idDangBaoChe",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: COMBO_BOX,
    label: "Đơn vị tính",
   
    name: "idDonViTinh",
   
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },

  {
    type: INPUT,
    label: "Đơn giá BH",
    name: "donGiaBaoHiem",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT_NUMBER,
    name: "donGiaBv",
    label: "Đơn giá BV",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},

  },
  {
    type: INPUT,
    label: "Số Đăng kí",
    name: "soDangKi",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT,
    label: "Quy cách",
    name: "quyCach",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT,
    label: "Mã CSKCB",
    name: "maCskcb",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: COMBO_BOX,
    label: "Loại thuốc",
    name: "loaiThuoc",
    
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: COMBO_BOX,
    label: "Đường dùng",
    name: "idDuongDung",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT,
    label: "Mã đường dùng",
    name: "maDuongDung",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT,
    label: "Nước sản xuất",
    name: "nuocSanXuat",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT,
    label: "Nhà sản xuất",
    name: "nhaSanXuat",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT_NUMBER,
    label: "Số lượng thầu",
    name: "soLuong",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT,
    label: "QĐ Thầu",
    name: "quyetDinhThau",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: DATE,
    label: "Từ ngày",
    name: "tuNgay",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
    disableDate: false,
  },
  {
    type: DATE,
    label: "Đến ngày",
    name: "denNgay",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
    disableDate: false,
  },
  {
    type: INPUT,
    label: "Nhà thầu",
    name: "nhaThau",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },
  {
    type: INPUT,
    label: "Loại Thầu",
    name: "loaiThau",
    css: {xs: 24, sm: 12, md: 12, lg: 12, xl: 12},
  },

 
];
export {dataFields};
